/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getFeedSkeleton.defs.js'
export { main as default } from './getFeedSkeleton.defs.js'
